/**
 * Returns whether or not the given Maps content are strictly equal.
 */
export function isMapEqual<K, V>(mapA: ReadonlyMap<K, V>, mapB: ReadonlyMap<K, V>): boolean {
    if (mapA === mapB) {
        return true;
    }

    if (mapA.size !== mapB.size) {
        return false;
    }

    for (const [key, value] of mapA) {
        if (!mapB.has(key) || mapB.get(key) !== value) {
            return false;
        }
    }

    return true;
}
